/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import MoserObject from './MoserObject';
import MoserObjectUtils from './MoserObjectUtils';
import FacetTypeEnabled from './FacetTypeEnabled';
import ContextMode from './ContextMode';
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
//@import com/ibm/bi/platform/moser/common/utils/MoserObjectUtils (runtime) // propertyOverrideForFacetType
//@import com/ibm/bi/platform/moser/common/generated/metadata/FacetTypeEnabled (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/ContextMode (runtime) // new

/**
 * <p>Java class for facetType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="facetType"&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="enabled" type="{}facetTypeEnabled"/&gt; &lt;element name="sortList" type="{}sortListType" minOccurs="0"/&gt; &lt;element name="context" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="ref" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="mode" type="{}contextMode" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class FacetType extends MoserObject{

	enabled = null;

	sortList = null;

	context = null;



	/**
	 * Gets the value of the enabled property.
	 * @return {FacetTypeEnabled} possible object is {@link FacetTypeEnabled}
	 */
	getEnabled() {
		return this.enabled;
	}

	/**
	 * Sets the value of the enabled property.
	 * @param {FacetTypeEnabled} value allowed object is {@link FacetTypeEnabled}
	 */
	setEnabled(value) {
		var oldValue = this.enabled;
		this.enabled = value;
		this._setAndNotify(17, oldValue, value, false, false);
		MoserObjectUtils.propertyOverrideForFacetType(this);
	}

	/**
	 * Gets the value of the sortList property.
	 * @return {SortListType} possible object is {@link SortListType}
	 */
	getSortList() {
		return this.sortList;
	}

	/**
	 * Sets the value of the sortList property.
	 * @param {SortListType} value allowed object is {@link SortListType}
	 */
	setSortList(value) {
		var oldValue = this.sortList;
		this.sortList = value;
		this._setAndNotify(18, oldValue, value, true, false);
		MoserObjectUtils.propertyOverrideForFacetType(this);
	}

	/**
	 * Gets the value of the context property.
	 * @return {Context} possible object is {@link FacetType.Context}
	 */
	getContext() {
		return this.context;
	}

	/**
	 * Sets the value of the context property.
	 * @param {Context} value allowed object is {@link FacetType.Context}
	 */
	setContext(value) {
		var oldValue = this.context;
		this.context = value;
		this._setAndNotify(2, oldValue, value, true, false);
	}

	/**
	 * Creates a new instance of <code>FacetType</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> FacetType</code> object from.
	 * @return {FacetType} an object of type <code>FacetType</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createFacetType();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "FacetType";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, true, false, 17, "enabled", FacetTypeEnabled));
		var clazz;
		if (factory) {
			clazz = factory.createSortListType().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 18, "sortList", clazz));
		if (factory) {
			clazz = factory.createFacetTypeContext().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 2, "context", clazz));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 2:
			this.setContext((value));
			break;
		case 17:
			this.setEnabled((value));
			break;
		case 18:
			this.setSortList((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 2:
			return this.getContext();
		case 17:
			return this.getEnabled();
		case 18:
			return this.getSortList();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 2:
			return this.getContext();
		case 17:
			return this.getEnabled();
		case 18:
			return this.getSortList();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}
/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="ref" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="mode" type="{}contextMode" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
FacetType.Context = class extends MoserObject{

	ref = null;

	mode = null;

	_referencedObject = null;



	/**
	 * Gets the value of the ref property.
	 * @return {String} possible object is {@link String}
	 */
	getRef() {
		return this.ref;
	}

	/**
	 * Sets the value of the ref property.
	 * @param {String} value allowed object is {@link String}
	 */
	setRef(value) {
		var oldValue = this.ref;
		this.ref = value;
		this._setAndNotify(36, oldValue, value, false, false);
		this._referencedObject = null;
	}

	/**
	 * Gets the value of the mode property.
	 * @return {ContextMode} possible object is {@link ContextMode}
	 */
	getMode() {
		return this.mode;
	}

	/**
	 * Sets the value of the mode property.
	 * @param {ContextMode} value allowed object is {@link ContextMode}
	 */
	setMode(value) {
		var oldValue = this.mode;
		this.mode = value;
		this._setAndNotify(182, oldValue, value, false, false);
	}

	/**
	 * Creates a new instance of <code>Context</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> Context</code> object from.
	 * @return {Context} an object of type <code>Context</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createFacetTypeContext();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "Context";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 36, "ref", null));
		featureList.push(this.createFeature(false, true, false, 182, "mode", ContextMode));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 182:
			this.setMode((value));
			break;
		case 36:
			this.setRef((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 182:
			return this.getMode();
		case 36:
			return this.getRef();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 182:
			return this.getMode();
		case 36:
			return this.getRef();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Set the resolved object based on reference.
	 * @param {MoserObject} referencedObject the referenced <code>MoserObject</code>
	 */
	setReferencedObject(referencedObject) {
		this._referencedObject = referencedObject;
	}

	/**
	 * Get the resolved object based on reference.
	 * @return {MoserObject} the referenced <code>MoserObject</code>
	 */
	getReferencedObject() {
		return this._referencedObject;
	}

	clone() {
		var cloned = (super.clone());
		cloned.setReferencedObject(this._referencedObject);
		return cloned;
	}
}


// WEBPACK FOOTER //
// ./src/generated/FacetType.js